import React, { useRef, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const testimonials = [
  {
    name: "RAMESH",
    review: "Purchased cocopeat bricks for my garden. The quality is excellent! Retains water well and has improved my plant growth significantly.",
    stars: 5,
    avatar: "R"
  },
  {
    name: "SITA",
    review: "The cocopeat from Tirumala Cocopeat is of superior quality. My terrace garden is flourishing, and it's eco-friendly too. Highly recommend!",
    stars: 5,
    avatar: "S"
  },
  {
    name: "RAHUL",
    review: "Great product for potted plants! Helps in water retention and enhances root growth. I've noticed visible results within a week.",
    stars: 5,
    avatar: "R"
  }
];

const StarRating = ({ stars }) => (
  <div className="flex items-center mb-2">
    {[...Array(5)].map((_, index) => (
      <svg 
        key={index} 
        xmlns="http://www.w3.org/2000/svg" 
        className={`h-5 w-5 ${index < stars ? 'text-yellow-400' : 'text-gray-300'}`}
        viewBox="0 0 24 24" 
        fill="currentColor"
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
      </svg>
    ))}
  </div>
);

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Auto-rotate testimonials every 5 seconds
    intervalRef.current = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleDotClick = (index) => {
    setActiveTestimonial(index);
    // Reset interval when manually changed
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
  };

  return (
    <div className="bg-gradient-to-br from-green-50 to-green-100 py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-3xl md:text-4xl font-extrabold text-green-800 mb-12">
          Customer Testimonials
        </h2>
        
        <div className="relative overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div 
              key={activeTestimonial}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
              className="bg-white shadow-2xl rounded-2xl p-8 md:p-12 text-center relative"
              style={{ overflow: 'hidden' }}
            >
              <div className="absolute top-4 left-4 bg-green-100 text-green-800 w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold">
                {testimonials[activeTestimonial].avatar}
              </div>
              
              <StarRating stars={testimonials[activeTestimonial].stars} />
              
              <p className="text-gray-600 italic text-base md:text-lg mb-6 min-h-[100px]">
                "{testimonials[activeTestimonial].review}"
              </p>
              
              <p className="text-lg md:text-xl font-bold text-green-700">
                {testimonials[activeTestimonial].name}
              </p>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Dots */}
          <div className="flex justify-center space-x-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => handleDotClick(index)}
                className={`h-3 w-3 rounded-full transition-all duration-300 ${
                  activeTestimonial === index 
                    ? 'bg-green-600 w-6' 
                    : 'bg-green-200'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;